// `"undefined"`/`"null"` are rejected alongside empty: a caller that interpolates an undefined id
// into a string yields the literal token, which would otherwise build `/api/image/undefined` and
// hit the blob proxy for a blob that never exists.
const INVALID_IMAGE_SRC_TOKENS = new Set(["", "undefined", "null"]);

export function getImageUrl(src: string, size?: number): string {
  if (!src || INVALID_IMAGE_SRC_TOKENS.has(src.trim().toLowerCase())) return "";
  return `/api/image/${size ? src.split(".").join(`_${size}x${size}.`) : src}`;
}
